



import Vue from "vue";
import NovelCreateForm from "@/components/organisms/NovelCreateForm.vue";
export default Vue.extend({
  components: { NovelCreateForm },
  created() {
    window.scrollTo(0, 0);
  },
});
